let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hLyDS")).then(() => parcelRequire('bCOVd'));